import { useParams, useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Header from './Component/Header';
import Footer from './Component/Footer';
import Request from './Component/requestEstimate';
import axios from 'axios';

function Productdetail() {
  const navigate = useNavigate();
  const { id, category } = useParams();
  const [imageData, setImageData] = useState([]);
  const [data1, setdata1] = useState([]);
  const [data2, setdata2] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    phoneNumber: '',
    email: '',
    zip: '',
    productlink: window.location.href,
    ProductName: '',
    sku: '',
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const FormData = {
          idd: id,
          cat: category,
        };

        const imageDataResponse = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/fetchimage/id`,
          FormData
        );

        setFormData((prev) => ({
          ...prev,
          sku: imageDataResponse.data.data1?.SKU,
          ProductName: imageDataResponse.data.data1?.Title,
          productlink: window.location.href,
        }));
        setImageData(imageDataResponse.data.data1);
        setdata1(imageDataResponse.data.data2);
        setdata2(imageDataResponse.data.data3);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [category, id]);

  const handlepropertyselect = (skuId, cat) => {
    navigate(`/products/${cat}/${skuId}`);
    window.scrollTo(0, 0);
  };

  const handleSubmitQUOTE = async (event) => {
    event.preventDefault();

    try {
      const formresponse = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/form`,
        formData
      );
      alert(formresponse.data.data1);
      setModalOpen(false);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const productColor = imageData.Color || imageData.color;

  const specs = [
    { label: 'Brand', value: imageData.Brand },
    { label: 'Product Line', value: imageData.Product_Line },
    { label: 'Color', value: productColor },
    { label: 'SKU #', value: imageData.SKU },
    { label: 'Thickness', value: imageData.Thickneess },
    { label: 'Width', value: imageData.Width },
    { label: 'Length', value: imageData.length },
    { label: 'Application', value: imageData.Application },
    { label: 'Color Tones', value: imageData.Color_Tones },
    { label: 'Material', value: imageData.Material },
    { label: 'Surface Type', value: imageData.Surface_Type },
    { label: 'Fiber Brand', value: imageData.Fiber_Brand },
    { label: 'Pattern Repeat Width', value: imageData.PatternRepeatWidth },
    { label: 'Pattern Repeat Length', value: imageData.PatternRepeatLength },
    { label: 'Width Face Weight', value: imageData.WidtFaceWeighth },
  ].filter((row) => row.value);

  return (
    <div className="bg-gray-50 min-h-screen">
      <Header />

      <div className="container mx-auto px-4 py-4 md:py-6">
        <nav aria-label="breadcrumb" className="mb-4">
          <ol className="flex flex-wrap items-center gap-2 text-sm text-gray-500 list-none m-0 p-0">
            <li>
              <a href="/" className="hover:text-[#0075ca] no-underline text-gray-500">
                Home
              </a>
            </li>
            <li className="text-gray-300">/</li>
            <li>
              <a href="/products" className="hover:text-[#0075ca] no-underline text-gray-500">
                Products
              </a>
            </li>
            {category && (
              <>
                <li className="text-gray-300">/</li>
                <li>
                  <a
                    href={`/products/${category}`}
                    className="hover:text-[#0075ca] no-underline text-gray-500 capitalize"
                  >
                    {category.replace(/-/g, ' ')}
                  </a>
                </li>
              </>
            )}
            <li className="text-gray-300">/</li>
            <li className="text-gray-800 font-medium truncate max-w-[140px] sm:max-w-none">
              {imageData.Product_Line || 'Details'}
            </li>
          </ol>
        </nav>

        <button
          type="button"
          className="mb-4 inline-flex items-center gap-2 text-sm font-medium text-gray-700 hover:text-[#0075ca] bg-white border border-gray-200 rounded-lg px-3 py-2 transition-colors"
          onClick={() => {
            window.history.back();
            window.scrollTo(0, 0);
          }}
        >
          <i className="bi bi-arrow-left" />
          Go Back
        </button>

        {/* Product hero card */}
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden mb-8">
          <div className="row g-0">
            <div className="col-lg-5">
              <div className="bg-gray-100 h-100 min-h-[260px] sm:min-h-[360px] flex items-center justify-center p-4 md:p-8">
                <img
                  src={require('./Component/photo/' + id + '.png')}
                  alt={imageData.Image_Title || imageData.Product_Line || 'Product'}
                  title={imageData.Image_Title}
                  className="max-h-[320px] md:max-h-[400px] w-auto max-w-full object-contain"
                />
              </div>
            </div>

            <div className="col-lg-7">
              <div className="p-5 md:p-8 flex flex-col h-100">
                <p className="text-xs font-semibold uppercase tracking-wide text-[#0075ca] mb-2 m-0 capitalize">
                  {(imageData.Type || category || '').replace(/-/g, ' ')}
                </p>
                <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
                  {imageData.Product_Line}
                  {imageData.Brand ? ` — ${imageData.Brand}` : ''}
                </h1>
                <p className="text-sm text-gray-500 mb-4">SKU# {imageData.SKU}</p>

                {productColor && (
                  <p className="text-sm text-gray-600 mb-4">
                    <span className="font-semibold text-gray-500">Color:</span>{' '}
                    <span className="text-gray-900">{productColor}</span>
                  </p>
                )}

                <button
                  type="button"
                  onClick={() => setModalOpen(true)}
                  className="inline-flex items-center justify-center gap-2 self-start bg-[#0075ca] text-white font-semibold text-sm px-5 py-2.5 rounded-lg border-0 hover:bg-[#0063ad] transition-colors mb-6 cursor-pointer"
                >
                  Request more info
                  <i className="bi bi-arrow-right" />
                </button>

                {data1.length > 0 && (
                  <div className="mt-auto">
                    <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-3">
                      Available colors
                    </p>
                    <ul className="flex flex-wrap gap-2 m-0 p-0 list-none">
                      {data1.map((item) => (
                        <li key={item.SKU_Id}>
                          <button
                            type="button"
                            className={`p-1 rounded-lg border transition-all bg-white ${
                              item.SKU === id
                                ? 'border-[#0075ca] ring-2 ring-[#0075ca]/20'
                                : 'border-gray-200 hover:border-[#0075ca]'
                            }`}
                            onClick={() => handlepropertyselect(item.SKU, item.Type)}
                            title={item.Color || item.color}
                          >
                            <img
                              src={require('./Component/photo/' + item.SKU + '.png')}
                              alt={item.Color || item.color || 'Color option'}
                              title={item.Color || item.color}
                              className="h-12 w-12 object-cover rounded-md"
                            />
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Specs */}
        {specs.length > 0 && (
          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden mb-8">
            <div className="px-5 md:px-8 py-4 border-b border-gray-100">
              <h2 className="text-lg md:text-xl font-bold text-gray-900 m-0">
                Specifications
              </h2>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm mb-0">
                <tbody>
                  {specs.map((row, index) => (
                    <tr
                      key={row.label}
                      className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}
                    >
                      <th
                        scope="row"
                        className="text-start font-semibold text-gray-600 px-5 md:px-8 py-3 whitespace-nowrap w-[40%] md:w-[28%]"
                      >
                        {row.label}
                      </th>
                      <td className="text-gray-900 px-5 md:px-8 py-3">{row.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Similar products */}
        {data2.length > 0 && (
          <section className="mb-4">
            <h2 className="text-lg md:text-xl font-bold text-gray-900 mb-4">
              Similar Products
            </h2>
            <div className="row g-3 g-md-4">
              {data2.map((item) => (
                <div key={item.SKU} className="col-6 col-md-4 col-lg-3" id={item.Brand}>
                  <button
                    type="button"
                    onClick={() => handlepropertyselect(item.SKU, item.Type)}
                    className="group w-100 h-100 bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden text-start p-0 transition-all hover:-translate-y-1 hover:shadow-md"
                  >
                    <div className="aspect-square bg-gray-100 overflow-hidden">
                      <img
                        src={require('./Component/photo/' + item.SKU + '.png')}
                        alt={`${item.Brand} ${item.Product_Line}`}
                        className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                      />
                    </div>
                    <div className="p-3 md:p-4">
                      <p className="text-xs text-gray-500 m-0 mb-1">{item.Brand}</p>
                      <p className="text-sm font-semibold text-gray-900 m-0 mb-1 line-clamp-2">
                        {item.Product_Line}
                      </p>
                      <p className="text-xs text-gray-600 m-0 mb-3">
                        {item.Color || item.color}
                      </p>
                      <span
                        className="inline-flex w-full items-center justify-center text-white text-xs font-semibold py-2 rounded-lg"
                        style={{ backgroundColor: '#0075ca' }}
                      >
                        See more colors
                      </span>
                    </div>
                  </button>
                </div>
              ))}
            </div>
          </section>
        )}
      </div>

      <section className="bg-white border-y border-gray-100">
        <Request />
      </section>
      <Footer />

      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4 backdrop-blur-sm">
          <div className="relative w-full max-w-md">
            <div className="relative overflow-hidden rounded-2xl bg-white shadow-xl border border-gray-100">
              <button
                type="button"
                onClick={() => setModalOpen(false)}
                className="absolute right-3 top-3 inline-flex h-8 w-8 items-center justify-center rounded-lg text-gray-400 transition hover:bg-gray-100 hover:text-gray-700 border-0 bg-transparent"
              >
                <i className="bi bi-x-lg" />
                <span className="sr-only">Close modal</span>
              </button>

              <form className="bg-gray-50 px-5 pb-2 pt-6 sm:px-6" onSubmit={handleSubmitQUOTE}>
                <div className="text-center">
                  <p className="text-xl font-extrabold tracking-tight text-[#0075ca] sm:text-2xl m-0">
                    LET&apos;S GET STARTED
                  </p>
                  <p className="mt-1 text-sm font-medium uppercase tracking-wide text-gray-600 m-0">
                    On your free quote!
                  </p>
                </div>

                <div className="mt-5 flex w-full flex-col justify-center text-gray-900">
                  <div className="pb-2">
                    <input
                      type="text"
                      className="h-11 w-full rounded-lg border border-gray-200 bg-white px-3 text-sm outline-none transition placeholder:text-gray-400 hover:border-[#0075ca]/50 focus:border-[#0075ca] focus:ring-4 focus:ring-[#0075ca]/20"
                      id="firstname"
                      placeholder="Full Name"
                      value={formData.firstName}
                      onChange={(e) =>
                        setFormData({ ...formData, firstName: e.target.value })
                      }
                      required
                    />
                  </div>
                  <div className="py-1.5">
                    <input
                      type="number"
                      className="h-11 w-full rounded-lg border border-gray-200 bg-white px-3 text-sm outline-none transition placeholder:text-gray-400 hover:border-[#0075ca]/50 focus:border-[#0075ca] focus:ring-4 focus:ring-[#0075ca]/20"
                      id="phoneNumber"
                      placeholder="Phone Number"
                      maxLength={10}
                      value={formData.phoneNumber}
                      onChange={(e) =>
                        setFormData({ ...formData, phoneNumber: e.target.value })
                      }
                      required
                    />
                  </div>
                  <div className="py-1.5">
                    <input
                      type="text"
                      className="h-11 w-full rounded-lg border border-gray-200 bg-white px-3 text-sm outline-none transition placeholder:text-gray-400 hover:border-[#0075ca]/50 focus:border-[#0075ca] focus:ring-4 focus:ring-[#0075ca]/20"
                      id="email"
                      placeholder="Email"
                      value={formData.email}
                      onChange={(e) =>
                        setFormData({ ...formData, email: e.target.value })
                      }
                      required
                    />
                  </div>
                  <div className="py-1.5">
                    <input
                      type="number"
                      className="h-11 w-full rounded-lg border border-gray-200 bg-white px-3 text-sm outline-none transition placeholder:text-gray-400 hover:border-[#0075ca]/50 focus:border-[#0075ca] focus:ring-4 focus:ring-[#0075ca]/20"
                      id="address"
                      placeholder="Zip Code"
                      value={formData.zip}
                      onChange={(e) =>
                        setFormData({ ...formData, zip: e.target.value })
                      }
                      required
                    />
                  </div>
                  <div className="py-3 text-[10px] font-semibold leading-relaxed text-gray-600 sm:text-xs">
                    By clicking GET QUOTE, I consent to communications from us via
                    email and phone about sales and events. Consent isn&apos;t
                    required for purchase. I can revoke it by calling or replying
                    STOP. Calls are recorded. I agree to the policies.
                  </div>
                </div>

                <div className="flex items-center justify-center pb-5 pt-1">
                  <button
                    type="submit"
                    disabled={!(formData.phoneNumber.length === 10)}
                    className="flex w-full items-center justify-center rounded-lg bg-[#0075ca] px-4 py-3 text-white border-0 transition hover:bg-[#0063ad] disabled:cursor-not-allowed disabled:opacity-50"
                  >
                    <span className="text-lg font-bold sm:text-xl">GET QUOTE!</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Productdetail;
